'use client'

import { ReactNode } from 'react'

import { NavigationButton } from '../NavigationButton'

type Props = {
  children: ReactNode
  currentIndex: number
  maxIndex: number
  onNavigate: (direction: 'prev' | 'next') => void
  testId: string
  progressBar?: ReactNode
}

export const ContentWithNavigation = ({
  children,
  currentIndex,
  maxIndex,
  onNavigate,
  testId,
  progressBar,
}: Props) => (
  <>
    {progressBar}
    <div
      key={`${testId}-${currentIndex}`}
      className="phishing-first-time-lister-education__conversation-slide-in"
      data-testid={testId}
    >
      {children}
    </div>

    <div className="phishing-first-time-lister-education__nav-button-left">
      <NavigationButton
        direction="prev"
        isVisible={currentIndex > 0}
        onClick={() => onNavigate('prev')}
        testId={`${testId}--navigation-prev`}
      />
    </div>

    <div className="phishing-first-time-lister-education__nav-button-right">
      <NavigationButton
        direction="next"
        isVisible={currentIndex < maxIndex}
        onClick={() => onNavigate('next')}
        testId={`${testId}--navigation-next`}
      />
    </div>
  </>
)
